import React from 'react'
import * as Yup from 'yup'
import PropTypes from 'prop-types'
import { Formik, Form } from 'formik'
import { makeStyles } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import {
  TextField,
  Typography,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from '@material-ui/core'

import CancelButton from 'app/components/buttons/CancelButton'
import DeleteButton from 'app/components/buttons/DeleteButton'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'
import ResponsiveDialogAction from 'app/components/dialog/ResponsiveDialogAction'

const DELETE = 'DELETE'

const useStyles = makeStyles(() => ({
  bgDisable: {
    backgroundColor: '#e5e5e5',
    color: '#a8a8a8',
  },
}))

function ReConfirmDeleteAdminDialog({
  isOpen = false,
  onClose,
  onDelete,
  isLoading,
}) {
  const classes = useStyles()

  const validSchema = Yup.object().shape({
    input: Yup.string()
      .test('is-delete', '', async (value) => {
        if (value.toUpperCase() === DELETE) {
          return true
        } else {
          return false
        }
      })
      .required(''),
  })

  return (
    <ResponsiveDialog
      open={isOpen}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      fullWidth
      maxWidth="sm"
      classes={{ paper: 'overflow-y-visible' }}
    >
      <Formik
        initialValues={{ input: '' }}
        validationSchema={validSchema}
        // to do arg values, actions
        onSubmit={() => {
          onDelete()
        }}
      >
        {(props) => (
          <Form>
            <DialogTitle id="alert-dialog-title">
              <div className="flex justify-between items-center">
                <Typography variant="h6" className="uppercase">
                  <FormattedMessage id="delete.account.reConfirm.button.lable" />
                </Typography>
              </div>
            </DialogTitle>
            <DialogContent>
              <DialogContentText className="text-black space-y-3">
                <Typography className="mb-5">
                  <FormattedMessage
                    id="delete.account.reConfirm.description.lable"
                    values={{ b: (text) => <b>{text}</b> }}
                  />
                </Typography>
                <TextField
                  id="input-delete"
                  name="input"
                  onChange={props.handleChange}
                  value={props.values.input}
                  label={
                    <FormattedMessage id="delete.account.reConfirm.input.lable" />
                  }
                  variant="outlined"
                  className="w-full"
                />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <ResponsiveDialogAction
                StartButton={
                  <CancelButton
                    disabled={isLoading}
                    onClick={() => {
                      onClose()
                    }}
                    className="w-full"
                  />
                }
                EndButton={
                  <DeleteButton
                    type="submit"
                    disabled={!props.dirty || !props.isValid || isLoading}
                    isLoading={isLoading}
                    className={
                      !props.dirty || !props.isValid ? classes.bgDisable : ''
                    }
                  />
                }
              />
            </DialogActions>
          </Form>
        )}
      </Formik>
    </ResponsiveDialog>
  )
}

ReConfirmDeleteAdminDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default ReConfirmDeleteAdminDialog
